// extracted by mini-css-extract-plugin
module.exports = {"backButton":"BackButton_backButton__18SxD","backButtonIcon":"BackButton_backButtonIcon__3xta3"};